export interface ModalStackEntry {
    id: symbol;
    isVisible: () => boolean;
    closeOnEsc: () => boolean;
    isStatic: () => boolean;
    reject: () => void;
}

const modalStackEntries: ModalStackEntry[] = [];
let isGlobalModalKeydownBound = false;

const isEscapeKey = (key: string): boolean => {
    return key === 'Escape' || key === 'Esc';
};

const syncDocumentBodyModalState = (): void => {
    if (typeof document === 'undefined') return;

    const hasStaticVisibleModal = modalStackEntries.some((entry) => {
        return entry.isVisible() && entry.isStatic();
    });

    if (hasStaticVisibleModal) {
        document.body.classList.add('modal-open');
        document.body.style.overflow = '';
        return;
    }

    document.body.classList.remove('modal-open');
    document.body.style.overflow = 'auto';
};

const removeModalStackEntryById = (entryId: symbol): void => {
    const entryIndex = modalStackEntries.findIndex((entry) => {
        return entry.id === entryId;
    });
    if (entryIndex > -1) {
        modalStackEntries.splice(entryIndex, 1);
    }
};

const handleGlobalModalKeydown = (event: KeyboardEvent): void => {
    if (!isEscapeKey(event.key)) return;

    const topEntry = modalStackEntries[modalStackEntries.length - 1];
    if (!topEntry || !topEntry.isVisible() || !topEntry.closeOnEsc()) return;

    topEntry.reject();
};

export const pushModalStackEntry = (entry: ModalStackEntry): void => {
    removeModalStackEntryById(entry.id);
    modalStackEntries.push(entry);

    if (!isGlobalModalKeydownBound && typeof document !== 'undefined') {
        document.addEventListener('keydown', handleGlobalModalKeydown);
        isGlobalModalKeydownBound = true;
    }

    syncDocumentBodyModalState();
};

export const releaseModalStackEntry = (entryId: symbol): void => {
    removeModalStackEntryById(entryId);

    if (
        modalStackEntries.length === 0 &&
        isGlobalModalKeydownBound &&
        typeof document !== 'undefined'
    ) {
        document.removeEventListener('keydown', handleGlobalModalKeydown);
        isGlobalModalKeydownBound = false;
    }

    syncDocumentBodyModalState();
};
